export const getBarBackgroundColor = (
    value: number,
    goal: number | null,
    page: number,
    itemIndex: number,
    totalItems: number,
    colors: { progressBold: string; progressStarGold: string },
) =>
    getBarColor(
        value,
        goalWasReached(goal, value),
        isLastWeek(page, itemIndex, totalItems),
        colors,
    );

const getBarColor = (
    lessonTaken: number,
    goalAchieved: boolean | undefined,
    isLastWeek: boolean,
    colors: { progressBold: string; progressStarGold: string },
) => {
    if (lessonTaken === 0) {
        return '#b6bbc6';
    }

    const color = goalAchieved ? colors.progressStarGold : colors.progressBold;

    return isLastWeek ? color : `${color}80`;
};

export const goalWasReached = (goal: number | null, value: number) => !!goal && value >= goal;

const isLastWeek = (page: number, itemIndex: number, itemsCount: number) =>
    page === 0 && itemIndex === itemsCount - 1;
